var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaintenanceAndRepairs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.41397 8.5L2.03097 15.918C1.83532 16.1123 1.68004 16.3435 1.57408 16.5981C1.46812 16.8527 1.41357 17.1257 1.41357 17.4015C1.41357 17.6773 1.46812 17.9503 1.57408 18.2049C1.68004 18.4595 1.83532 18.6907 2.03097 18.885C2.42634 19.2783 2.96132 19.499 3.51897 19.499C4.07662 19.499 4.6116 19.2783 5.00697 18.885L12.414 11.5M16.1209 13.7931L18.7069 11.2071C18.8944 11.0196 18.9997 10.7653 18.9997 10.5001C18.9997 10.2349 18.8944 9.98062 18.7069 9.79309L11.1209 2.20709C10.9334 2.01962 10.6791 1.91431 10.4139 1.91431C10.1487 1.91431 9.89444 2.01962 9.70691 2.20709L7.12091 4.79309C6.93344 4.98062 6.82812 5.23493 6.82812 5.50009C6.82812 5.76526 6.93344 6.01957 7.12091 6.20709L14.7069 13.7931C14.8944 13.9806 15.1487 14.0859 15.4139 14.0859C15.6791 14.0859 15.9334 13.9806 16.1209 13.7931Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenanceAndRepairs);
export default __webpack_public_path__ + "static/media/maintenance_and_repairs.163c1ce3123dfe3e2d9e58df48cf345e.svg";
export { ForwardRef as ReactComponent };